export const customInputTypes = [
  {
      "id": 1,
      "name": "FreeText",
      "displayName": "Free Text"
  },
  {
      "id": 2,
      "name": "Paragraph",
      "displayName": "Paragraph"
  },
  {
      "id": 3,
      "name": "NumericInt",
      "displayName": "Numeric Integer"
  },
  {
      "id": 4,
      "name": "NumericDec",
      "displayName": "Numeric Decimal"
  },
  {
      "id": 5,
      "name": "Currency",
      "displayName": "Currency"
  },
  {
      "id": 6,
      "name": "Dropdown",
      "displayName": "Dropdown"
  },
  {
      "id": 7,
      "name": "Checkbox",
      "displayName": "Checkbox"
  },
  {
      "id": 8,
      "name": "Date",
      "displayName": "Date"
  },
  {
      "id": 9,
      "name": "Year",
      "displayName": "Year"
  }
];
